import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useToast } from "../../toast/ToastProvider";
import { setAuthUser } from "../../../Redux/Slices/authSlice";
import { useDispatch } from "react-redux";
import { userLogin, userSignUp } from "../../../service/LoginService";
import { Eye, EyeOff } from "react-feather";
import { validateEmail, validatePassword, validatePhone } from "../../../config/function";
import '../../../styles/userLogin.css'
import { fetchCustomer } from "../../../service/CustomerService";

const Login = () => {
  const navigate = useNavigate()
  const toast = useToast()
  const dispatch = useDispatch();
  const [isSignup, setIsSignup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showHint, setShowHint] = useState({ email: '', password: '' });


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      // Only allow up to 10 digits
      if (validatePhone(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else if (name === "password") {
      if (value && !validatePassword(value)) {
        setShowHint((prev) => ({
          ...prev,
          password:
            "Password must be at least 8 characters, include one uppercase, one number & one special character.",
        }));
      } else {
        setShowHint((prev) => ({ ...prev, password: "" }));
      }

      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


  // Handle Login Submit
  const handleLogin = async (e) => {
    e.preventDefault();
    let hasError = false;

    if (!validateEmail(formData.email)) {
      setShowHint(prev => ({ ...prev, email: 'Please enter a valid email address' }));
      hasError = true;
    } else {
      setShowHint(prev => ({ ...prev, email: '' }));
    }

    if (!validatePassword(formData.password)) {
      setShowHint(prev => ({
        ...prev,
        password: "Password must be at least 8 characters, include one uppercase, one number & one special character."
      }));
      hasError = true;
    } else {
      setShowHint(prev => ({ ...prev, password: '' }));
    }

    if (hasError) return;
    try {

      const res = await userLogin({
        email: formData.email,
        password: formData.password,
      }
      );
      dispatch(setAuthUser(res.data));
      toast("Login Successful", "SUCCESS");
      navigate('/')
    } catch (err) {
      toast("Login Failed", "ERROR");
    }
  };

  // Handle Signup Submit
  const handleSignup = async (e) => {
    e.preventDefault();


    if (!validatePassword(formData.password)) {
      setShowHint(
        " Password must be at least 8 characters, include one uppercase, one number & one special character."
      );
      return;
    }

    if (!validateEmail(formData.email)) {
      setShowHint('Please enter a valid email address');
      return;
    }
    try {

      const customer = await fetchCustomer();
      const exist = customer.some(item => item.email === formData.email);
      if (exist) {
        toast("Account already exists", "ERROR");
        return;
      }
      
      const res = await userSignUp({
        name: formData.name,
        email: formData.email,
        password: formData.password,
        phone: formData.phone,
      }
      );
      console.log("Signup Success:", res.data);
      toast("Register Successfully", "SUCCESS");
      setIsSignup(false);
    } catch (err) {
      toast("SignUp Failed", "ERROR");
    }
  };

  return (
    <div className="container-fluid vh-100">
      <div className="row h-100">
        {/* Left Image Section */}
        <div className="col-lg-5 col-md-8 d-none d-md-block">
          <img
            src="https://manubhai.in/SocialMedia/post_artworks/02042018092243MBCC13.jpg?ver=2"
            alt="Login Visual"
            className="img-fluid h-100 w-100"
            style={{ objectFit: "cover" }}
          />
        </div>
        <div className="col-lg-7 col-md-8 col-sm-12 d-flex align-items-center justify-content-center bg-light">
          <div className="w-100 d-flex align-items-center flex-column">
            <div className="col-4 mb-5">
              <img src="assets/images/logo.png" alt="logo" />
            </div>
            <div className="w-75 p-5 shadow rounded-4 bg-white">
              <h2 className="mb-4 text-center fw-bold">
                {isSignup ? "Create Account 😊" : "Welcome Back💐"}
              </h2>
              <p className="text-muted text-center mb-4">
                {isSignup
                  ? "Fill the details below to sign up"
                  : "Please log in to continue"}
              </p>
              <Form onSubmit={isSignup ? handleSignup : handleLogin} className="auth-form">
                {isSignup && (
                  <>
                    <Form.Group className="mb-4" controlId="formName">
                      <Form.Label className="auth-form-label">
                        Full Name
                      </Form.Label>
                      <div className="input-with-icon">
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Enter your full name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          className="auth-form-input"
                        />
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="formPhone">
                      <Form.Label className="auth-form-label">Phone</Form.Label>
                      <div className="input-with-icon">
                        <Form.Control
                          type="text"
                          name="phone"
                          placeholder="Enter your phone number"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          className="auth-form-input"
                        />
                      </div>
                    </Form.Group>
                  </>
                )}

                <Form.Group className="mb-4" controlId="formEmail">
                  <Form.Label className="auth-form-label">Email</Form.Label>
                  <div className="input-with-icon">
                    <Form.Control
                      type="text"
                      name="email"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="auth-form-input"
                    />
                  </div>
                  {showHint && (
                    <Form.Text className="show-hint">
                      {showHint.email}
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group className="mb-4" controlId="formPassword">
                  <Form.Label className="auth-form-label">Password</Form.Label>
                  <div className="input-with-icon">
                    <Form.Control
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      placeholder="Enter your password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      className="auth-form-input"
                    />
                    <span onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <EyeOff /> : <Eye />}

                    </span>
                  </div>
                  {showHint && (
                    <Form.Text className="show-hint">
                      {showHint.password}
                    </Form.Text>
                  )}

                </Form.Group>

                <div className="d-grid mt-4">
                  <Button
                    variant="primary"
                    type="submit"
                    className="auth-form-btn py-3 fw-bold"
                  >
                    {isSignup ? "Create Account" : "Sign In"}
                  </Button>
                </div>
              </Form>

              {/* Switch between Login & Signup */}
              <div className="text-center mt-3">
                {isSignup ? (
                  <p className="sign-text">
                    Already have an account?{" "}
                    <button
                      className="btn btn-link p-0 fw-semibold text-decoration-none"
                      onClick={() => setIsSignup(false)}
                    >
                      Log in here
                    </button>
                  </p>
                ) : (
                  <>
                    <Link
                      to='/forgot-password'
                      className="text-decoration-none d-block mb-2"
                      style={{ cursor: 'pointer', fontSize: '13px' }}
                    >
                      Forgot password?
                    </Link>
                    <p className="sign-text">
                      Don’t have an account?{" "}
                      <button
                        className="btn btn-link p-0 fw-semibold text-decoration-none"
                        onClick={() => setIsSignup(true)}
                      >
                        Create a new account
                      </button>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
